module.exports = {
    initial: 'initial',
    ready: 'ready',
    waiting: 'waiting'
};


/** WEBPACK FOOTER **
 ** ./src/constants/ui-state.js
 **/